export default __webpack_public_path__ + "fbf05735f714fe2b922b90a77368f480.png";